import imageCompression from 'browser-image-compression';

export const CommonImgCompresser = async (imageFile, options) => {
	// // true

	const optionsInner = {
		maxSizeMB: 1,
		maxWidthOrHeight: 1920,
		useWebWorker: true,
	};
	try {
		const compressedFile = await imageCompression(imageFile, options ? options : optionsInner);
		// // true
		// smaller than maxSizeMB

		let uploadableFile = new File([compressedFile], imageFile.name, {
			type: imageFile.type ? imageFile.type : 'image/jpeg',
		});

		return uploadableFile;
	} catch (error) {
		return null;
	}
};
